Namespace 'Common.Modals'

class Common.Modals.ModalView extends Backbone.View
  template: JST['backbone/templates/common/modals/modal']
  className: 'keepcon-modal-container'

  events:
    'click .keepcon-modal-close': 'closeModal'

  initialize: ({title, contentView, size, modalOptions}) ->
    throw new Error('size is mandatory for ModalView') unless size?.width && size?.height
    @title = title
    @contentView = contentView
    @listenTo contentView, 'modal:close', @closeModal
    @modal = new jBox 'Modal', _.extend({}, modalOptions,
      content: @$el
      isolateScroll: false
      closeButton: false
      zIndex: 'auto'
      onClose: @_onModalClose
      onCloseComplete: @_onModalCloseComplete
      width: size.width
      height: size.height
    )
    @

  render: ->
    @$el.empty().append @template
      title: @title
    @$('.keepcon-modal-body').empty().append @contentView.el
    @modal.open()
    @

  openModal: ->
    @modal.open()

  closeModal: ->
    @modal.close()

  _onModalClose: =>
    @trigger 'modal:closed'

  _onModalCloseComplete: =>
    @contentView.$el.detach()
    @modal.destroy()
    @trigger 'modal:destroyed'

  remove: ->
    @contentView.$el.detach()
    super()
